module.exports = __webpack_public_path__ + "static/img/anxun23.ab515e06.png";